import { getAPI , postAPI , putAPI } from "../../api";
import { REACT_APP_JOB } from "../../utils/common";

export async function getPositionsDetails(jobId: string){
    const Details = getAPI( REACT_APP_JOB + `/position/${jobId}`)
    return Details
}

export async function contractMetadata(body: any) {
    const Details = postAPI(REACT_APP_JOB + '/contract-metadata', body)
    return Details
}

export async function updatePositionStatus(body: any) {
    const Details = putAPI( REACT_APP_JOB + '/candidate-position-status', body)
    return Details
}